// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EraForEmailDomainDto } from '../models';
/**
 * UsersEraApi - axios parameter creator
 */
export const UsersEraApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailDomain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalRecruitmentAgenciesForEmailDomain: async (userId: string, emailDomain: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getExternalRecruitmentAgenciesForEmailDomain', 'userId', userId)
            // verify required parameter 'emailDomain' is not null or undefined
            assertParamExists('getExternalRecruitmentAgenciesForEmailDomain', 'emailDomain', emailDomain)
            const localVarPath = `/api/v1/users/{userId}/companies`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (emailDomain !== undefined) {
                localVarQueryParameter['emailDomain'] = emailDomain;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersEraApi - functional programming interface
 */
export const UsersEraApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersEraApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailDomain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalRecruitmentAgenciesForEmailDomain(userId: string, emailDomain: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EraForEmailDomainDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalRecruitmentAgenciesForEmailDomain(userId, emailDomain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersEraApi.getExternalRecruitmentAgenciesForEmailDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersEraApi - factory interface
 */
export const UsersEraApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersEraApiFp(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailDomain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalRecruitmentAgenciesForEmailDomain(userId: string, emailDomain: string, options?: RawAxiosRequestConfig): AxiosPromise<EraForEmailDomainDto> {
            return localVarFp.getExternalRecruitmentAgenciesForEmailDomain(userId, emailDomain, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersEraApi - interface
 */
export interface UsersEraApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {string} emailDomain 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExternalRecruitmentAgenciesForEmailDomain(userId: string, emailDomain: string, options?: RawAxiosRequestConfig): AxiosPromise<EraForEmailDomainDto>;

}

/**
 * UsersEraApi - object-oriented interface
 */
export class UsersEraApi extends BaseAPI implements UsersEraApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {string} emailDomain 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getExternalRecruitmentAgenciesForEmailDomain(userId: string, emailDomain: string, options?: RawAxiosRequestConfig) {
        return UsersEraApiFp(this.configuration).getExternalRecruitmentAgenciesForEmailDomain(userId, emailDomain, options).then((request) => request(this.axios, this.basePath));
    }
}

